import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { postLoginPath } from '../lib/appSurface';
import { safeRedirectOrDefault } from '../lib/safeRedirect';

export function PublicOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();

  if (loading) return null;

  if (user) {
    // Carry a pending invite through — otherwise an already-signed-in
    // viewer hitting /login?invite=<token> gets bounced to the organizer
    // dashboard and the invite flow dead-ends.
    const invite = searchParams.get('invite');
    if (invite) {
      return <Navigate to={`/invite/${encodeURIComponent(invite)}`} replace />;
    }
    // Return to the page the visitor came from (header Sign in carries it),
    // falling back to the dashboard. This guard re-renders the moment login
    // sets the user, so it must honour ?redirect= or it overrides
    // LoginPage's own post-login navigation.
    const redirect = safeRedirectOrDefault(
      searchParams.get('redirect'),
      postLoginPath(),
    );
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>;
}
